module.exports = __webpack_public_path__ + "img/ic_notification.6994be0d.svg";